import FeedRunningRecord from './FeedRunningRecord'

export default FeedRunningRecord
